import {
	Box,
	ResponsiveLayout,
	Stack,
	TelefonicaLogo,
	Text,
	Grid,
	useScreenSize,
	GridItem,
	Image,
	skinVars,
  Text2,
} from "@telefonica/mistica";
import React from "react";
import { strings } from "../../localization";
import { default as VivoCBF } from "../../assets/icons/VivoCBF.svg";
import { default as Vivo5G } from "../../assets/icons/Vivo5G.svg";
import { LinkList } from "../LinkList";

export const Footer: React.FC = () => {
	const { isMobile } = useScreenSize();
  
	return (
		<Box>
			<ResponsiveLayout isInverse className="text-justify">
				<div id="footer">
					<Box paddingBottom={56} paddingTop={56}>
            <LinkList />
						<Box paddingTop={isMobile ? 40 : 56}>
							<Box paddingBottom={24} className="text-align-center font-family-vivotype">
								<Text2 regular color={skinVars.colors.textPrimaryInverse}>
									{strings.components.footer.text1}
								</Text2>
							</Box>
							<Stack space={24}>
								<Text size={isMobile ? 10 : 12} color={skinVars.colors.textPrimaryInverse} lineHeight={isMobile ? 16 : 20} weight={"light"}>
									{strings.components.footer.text0}
								</Text>
							</Stack>
						</Box>
					</Box>
				</div>
			</ResponsiveLayout>

			<ResponsiveLayout backgroundColor={skinVars.colors.backgroundAlternative}>
				<Box paddingBottom={40} paddingTop={40}>
					<Stack space={48}>
						<Grid columns={isMobile ? 1 : 3} alignItems="center" justifyItems="center" rows={isMobile ? 3 : 1}>
							<GridItem justifySelf={isMobile ? "center" : "start"}>
								<TelefonicaLogo type="imagotype" size={62} />
							</GridItem>
							<GridItem>
								<Image src={VivoCBF} height={32} width={220} />
							</GridItem>
							<GridItem justifySelf={isMobile ? "center" : "end"}>
								<Image src={Vivo5G} height={32} width={73} />
							</GridItem>
						</Grid>
					</Stack>
				</Box>
			</ResponsiveLayout>
		</Box>
	);
};
